import { get } from "lodash";
export default function is401(err) {
    return get(err, "response.status") === 401;
}
export function isGraph401(res) {
    var useErrorHandler = get(res, "config.useErrorHandler", true);
    var found = false;
    if (useErrorHandler && res.data) {
        if (Array.isArray(res.data.errors)) {
            res.data.errors.forEach(function (_a) {
                var statusCode = _a.statusCode;
                if (statusCode === 401) {
                    found = true;
                }
            });
        }
    }
    if (res.status === 401) {
        found = true;
    }
    return found;
}
